import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "../../services/baseQuery";
import { buildPagedListUrl } from "../../services/queryParams";

export const inputBatchApi = createApi({
  reducerPath: "inputBatchApi",
  baseQuery: appBaseQuery,
  tagTypes: ["InputBatch"],
  endpoints: (builder) => ({
    getInputBatches: builder.query({
      query: (params = {}) => buildPagedListUrl("inputreadybatch/", params),
      providesTags: ["InputBatch"],
    }),
    addInputBatch: builder.mutation({
      query: (newInputBatch) => ({
        url: "inputreadybatch/",
        method: "POST",
        body: newInputBatch,
      }),
      invalidatesTags: ["InputBatch"],
    }),
    updateInputBatch: builder.mutation({
      query: ({ uid, ...updatedInputBatch }) => ({
        url: `inputreadybatch/${uid}`,
        method: "PUT",
        body: updatedInputBatch,
      }),
      invalidatesTags: ["InputBatch"],
    }),
    deleteInputBatch: builder.mutation({
      query: (uid) => ({
        url: `inputreadybatch/${uid}`,
        method: "DELETE",
      }),
      invalidatesTags: ["InputBatch"],
    }),
  }),
});

export const {
  useGetInputBatchesQuery,
  useLazyGetInputBatchesQuery,
  useAddInputBatchMutation,
  useUpdateInputBatchMutation,
  useDeleteInputBatchMutation,
} = inputBatchApi;
